import React from "react";
import {
  Store, ShoppingCart, Truck, Landmark, Cpu, Building2, Users, Megaphone,
  ArrowRight, CheckCircle2,
} from "lucide-react";

const ICON_MAP = {
  store: Store,
  "shopping-cart": ShoppingCart,
  truck: Truck,
  landmark: Landmark,
  cpu: Cpu,
  "building-2": Building2,
  users: Users,
  megaphone: Megaphone,
};

export default function CategoryCards({ categories, selected, onSelect }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {categories.map((cat, idx) => {
        const Icon = ICON_MAP[cat.icon] || Store;
        const isSelected = selected === cat.key;
        return (
          <button
            type="button"
            key={cat.key}
            data-testid={`category-card-${cat.key}`}
            data-selected={isSelected}
            onClick={() => onSelect(cat.key)}
            className="cat-card text-left p-5 fade-up"
            style={{ animationDelay: `${idx * 60}ms` }}
          >
            <div className="flex items-start justify-between mb-3">
              <span className="icon-bubble">
                <Icon size={22} strokeWidth={2.2} />
              </span>
              {isSelected && (
                <span className="text-[#2F9E44] flex items-center gap-1 text-xs font-semibold">
                  <CheckCircle2 size={14} /> Selected
                </span>
              )}
            </div>
            <h3 className="display text-[16px] font-bold text-[#0C1F4A] leading-snug mb-1.5">
              {cat.label}
            </h3>
            <p className="text-[13px] text-slate-600 leading-relaxed">{cat.desc}</p>
            <div className="mt-4 inline-flex items-center gap-1 text-[12px] font-semibold text-[#E96C0F]">
              {isSelected ? "Continue below" : "Choose this"} <ArrowRight size={13} />
            </div>
          </button>
        );
      })}
    </div>
  );
}
